// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"776ff6ed","628":"776ff6ed"}[chunkId] + ".chunk.css";
};